var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinklarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.96 3.04a5.85 5.85 0 0 0-8.26 0L9.42 6.32a7.12 7.12 0 0 1 4.2.51l1.44-1.43a2.5 2.5 0 0 1 3.54 3.54l-1.44 1.43-.96.96-1.14 1.15a2.49 2.49 0 0 1-3.24.24l-.3-.24c-.1-.1-.17-.2-.24-.3a1.25 1.25 0 0 0-1.46.22l-1.45 1.46a5.8 5.8 0 0 0 7.55 2.06 5.79 5.79 0 0 0 1.5-1.08l.26-.26 3.28-3.28a5.85 5.85 0 0 0 0-8.26Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.37 17.17 8.94 18.6a2.5 2.5 0 0 1-3.54-3.54l1.43-1.44.96-.95 1.15-1.15a2.49 2.49 0 0 1 3.24-.24l.3.24c.1.1.17.2.24.3.47.24 1.06.17 1.45-.22l1.45-1.45a5.76 5.76 0 0 0-2.96-2.35 5.86 5.86 0 0 0-6.08 1.36l-.26.26-3.28 3.28a5.85 5.85 0 0 0 8.26 8.26l3.28-3.28c-1.4.26-2.88.08-4.2-.51Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinklarge);
export default __webpack_public_path__ + "static/media/link.large.6442c94bae4533f1e18b2eaf43bbd97f.svg";
export { ForwardRef as ReactComponent };